<progress aria-valuemax="100"
          aria-valuemin="0"
          [attr.aria-busy]="progress() < 100 ? 'true' : null"
          [attr.aria-valuenow]="progress()"
          [id]="id">
  {{progress()}}%
</progress>

<div aria-hidden="true" data-bar [style.--width]="progress() + '%'"></div>

<label [for]="id">{{ label() }}</label>
